import { ConfigContext, TenantContext } from "context";
import { useStorageIdentity } from "hooks/useIdentity/useStorageIdentity";
import { useContext } from "react";
import { MetadataDto as Metadata } from "types";

interface UploaderParams {
    metadata?: Metadata[];
}

export default function useSpaTenantRoute() {

    const storageIdentity = useStorageIdentity();
    const tenant = useContext(TenantContext).tenant;

    const { concurrency, maxFileSize, filesLimit, fileType, inputFields } = useContext(ConfigContext).config.upload;

    const Uploader = ({ metadata }: UploaderParams) => {
        const url = new URL(`http://dummyurl/${tenant.path}/uploader`);
        addSearchParams('metadata', metadata ? encodeURIComponent(JSON.stringify(metadata)) : null);
        addSearchParams('concurrency', concurrency);
        addSearchParams('maxFileSize', maxFileSize);
        addSearchParams('filesLimit', filesLimit);
        addSearchParams('fileType', fileType);
        addSearchParams('inputFields', inputFields ? encodeURIComponent(JSON.stringify(inputFields)) : null);

        const token = storageIdentity.getIdentity()?.tokenV2;
        if (!token)
            throw new Error("No token found in storage identity");
        addSearchParams('token', token);

        return url.pathname + url.search;

        function addSearchParams(type: string, value: any) {
            if (value)
                url.searchParams.set(type, value.toString());
        }
    }
    return {
        routes: {
            Home: () => `/${tenant.path}/home`,
            Documents: () => `/${tenant.path}/documents`,
            Uploader,
        },
    };
}